import { Routes } from '@angular/router';
import { MakepaymentComponent } from './makepayment/makepayment.component';
import { PayreceiptComponent } from './payreceipt/payreceipt.component';
import { PaymentfailedComponent } from './paymentfailed/paymentfailed.component';
import { PendingComponent } from './pending/pending.component';
import { RefundComponent } from './refund/refund.component';
import { IsAuthenticatedGuard } from '../is-authenticated.guard';
var ɵ0 = {
    ROLES: ['VLE']
}, ɵ1 = {
    ROLES: ['1001']
};
var routes = [{ path: 'makepayment', component: MakepaymentComponent },
    { path: 'makepayment/:challanNo', component: MakepaymentComponent },
    { path: 'receipt/:id', component: PayreceiptComponent },
    { path: 'failed', component: PaymentfailedComponent },
    { path: 'pending', component: PendingComponent, canActivate: [IsAuthenticatedGuard],
        runGuardsAndResolvers: "always",
        data: ɵ0 },
    { path: 'refund', component: RefundComponent, canActivate: [IsAuthenticatedGuard],
        runGuardsAndResolvers: "always",
        data: ɵ1 }
];
var PaymentRoutingModule = /** @class */ (function () {
    function PaymentRoutingModule() {
    }
    return PaymentRoutingModule;
}());
export { PaymentRoutingModule };
export { ɵ0, ɵ1 };
